import React from "react";
import Button from "components/button";
import styled from "styled-components";
import { fonts } from "assets/fontStyles";
import { navigate } from "@reach/router";
import { string, element } from "prop-types";
import { Row } from "components/shared/layout";
import colours from "assets/colours";
import queries, { maxQuery } from "utils/responsivenessHelper";

const Icon = styled.img``;

const Title = styled.div`
  ${fonts.heading4};
`;

const SubTitle = styled.div`
  ${fonts.heading5};
`;

const BackButtonWrapper = styled.div`
  height: 50px;
  width: 50px;
  margin-right: 28px;

  button {
    background: ${colours.white};
    width: inherit;
    height: inherit;

    img {
      transform: rotate(90deg);
    }
  }
`;

const RightWrapper = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    min-width: 12.3125em;
  }
`;

const RightWrapperInner = styled(Row)`
  ${maxQuery.both({ margin: '20px auto' }, "850px")}
`;

const Left = styled(Row)`
  display: flex;
  width: 100%;

  ${queries.both({ flexWrap: "unset" })}
`;

const PageHeadContainer = styled.div`
  ${maxQuery.both({ display: 'block' }, "850px")}
  width: 100%;
  display: flex;
  margin: 55px 0px;
  padding: 0px 20px;
`;

const PageHead = ({ title, subTitle='', actionContext }) => {
  return (
    <PageHeadContainer>
      <Left alignItems="center">
        <BackButtonWrapper>
          <Button type="button" onClick={() => navigate(-1)}>
            <Icon
              src={require("assets/images/chevron-down-icon.svg")}
              alt="Navigate back"
            />
          </Button>
        </BackButtonWrapper>
        <Title>
          {title}
          <SubTitle>{subTitle}</SubTitle>
        </Title>
      </Left>

      <RightWrapper alignItems="center">
        <RightWrapperInner>
          {actionContext}
        </RightWrapperInner>
      </RightWrapper>
    </PageHeadContainer>
  );
};

export default PageHead;

PageHead.defaultProps = {
  title: "",
  actionContext: null,
};

PageHead.propTypes = {
  title: string,
  actionContext: element,
};
